import { isOpen } from "@rentiohq/shared-frontend/dist/utils/paymentRequest.utils";
import React from "react";
import { Navigate } from "react-router-dom";
import { TProps } from "./PaymentRequestRedirect.types";

class PaymentRequestRedirect extends React.Component<TProps> {
  // Render
  public render() {
    const { paymentRequest } = this.props;
    if (!paymentRequest) {
      return null;
    }

    if (isOpen(paymentRequest)) {
      return null;
    }

    return <Navigate to="/" />;
  }
}

// eslint-disable-next-line import/no-default-export
export default PaymentRequestRedirect;
